import { useLocation  } from "react-router-dom";
import { PropsWithChildren } from "react";
import AppBar from "../../navigation/AppBar/AppBar";
import BaseLayout from "../BaseLayout/BaseLayout";
import verifyCustomAppbarRoute from "./CustomAppbarRoutes";

const MainLayout = ({ children }: PropsWithChildren<object>): JSX.Element => {
    const location = useLocation();

    return (
        <BaseLayout>
            {!verifyCustomAppbarRoute(location.pathname) && <AppBar />}
            {children}
        </BaseLayout>
    );
};

export default MainLayout;
